export const AUTH_CLIENT_ID = 'AUTH_CLIENT_ID';
export const AUTH_CLIENT_ID_WEB = 'AUTH_CLIENT_ID_WEB';
export const AUTH_CLIENT_ID_MOBILE = 'AUTH_CLIENT_ID_MOBILE';
export const AUTH_RESPONSE_TYPE = 'AUTH_RESPONSE_TYPE';
export const CONTENTFUL_ENVIRONMENT = 'CONTENTFUL_ENVIRONMENT';
export const GOOGLE_BASE_URL = 'GOOGLE_BASE_URL';
export const GOOGLE_MAP_API_URL = 'GOOGLE_MAP_API_URL';
export const GOOGLE_PLACES_KEY = 'GOOGLE_PLACES_KEY';
export const GOOGLE_PLACES_COUNTRY = 'GOOGLE_PLACES_COUNTRY';
export const GUEST_SCOPE = 'GUEST_SCOPE';
export const GUEST_TOKEN_URL = 'GUEST_TOKEN_URL';
export const REFRESH_REQUEST_URL = 'REFRESH_REQUEST_URL';
export const SIGNOUT_URL = 'SIGNOUT_URL';
export const LOGOUT_URL = 'LOGOUT_URL';
export const TOKEN_INTERVAL_TIMEOUT_SECS = 'TOKEN_INTERVAL_TIMEOUT_SECS';
export const REFRESH_TOKEN_MAX_RETRY_COUNT = 'REFRESH_TOKEN_MAX_RETRY_COUNT';
export const REFRESH_TOKEN_EXPIRING_IN_SECS = 'REFRESH_TOKEN_EXPIRING_IN_SECS';
export const CHECK_ACCESS_TOKEN_INTERVAL_MILLIS = 'CHECK_ACCESS_TOKEN_INTERVAL_MILLIS';
export const TENANT_IMAGE_PATH = 'TENANT_IMAGE_PATH';
export const AUTH_CODE_METHOD = 'AUTH_CODE_METHOD';
export const BILLDESK_BASE_URL = 'BILLDESK_BASE_URL';
export const CONTENTFUL_SPACE = 'CONTENTFUL_SPACE';
export const GOOGLE_SPOT_CLIENT_ID = 'GOOGLE_SPOT_CLIENT_ID';
export const GOOGLE_SPOT_AUTH_SCOPE = 'GOOGLE_SPOT_AUTH_SCOPE';
export const GTM_KEY = 'GTM_KEY';
export const GUEST_CLIENT_ID = 'GUEST_CLIENT_ID';
export const GUEST_CLIENT_ID_WEB = 'GUEST_CLIENT_ID_WEB';
export const GUEST_CLIENT_ID_MOBILE = 'GUEST_CLIENT_ID_MOBILE';
export const LOGIN_DOMAIN = 'LOGIN_DOMAIN';
export const REGISTER_URL = 'REGISTER_URL';
export const LOGIN_PATH_NAME = 'LOGIN_PATH_NAME';
export const REFRESH_TOKEN_URL = 'REFRESH_TOKEN_URL';
export const TENANT_OS_ENDPOINT_BASE_URL = 'TENANT_OS_ENDPOINT_BASE_URL';
export const AUTHORIZATION_CODE = 'AUTHORIZATION_CODE';
export const AUTH_SCOPE = 'AUTH_SCOPE';
export const CONTENTFUL_ACCESS_TOKEN = 'CONTENTFUL_ACCESS_TOKEN';
export const DEVELOPMENT = 'DEVELOPMENT';
export const GOOGLE_SPOT_PRODUCTION = 'GOOGLE_SPOT_PRODUCTION';
export const GUEST_GRANT_TYPE = 'GUEST_GRANT_TYPE';
export const PAYTM_CALLBACK = 'PAYTM_CALLBACK';
export const PAYTM_IS_STAGING = 'PAYTM_IS_STAGING';
export const CRYPTO_SECRET_KEY = 'CRYPTO_SECRET_KEY';
export const PAYTM_POST_URL = 'PAYTM_POST_URL';
export const REFRESH_GRANT_TYPE = 'REFRESH_GRANT_TYPE';
export const TENANT_IMAGE_BASE_URL = 'TENANT_IMAGE_BASE_URL';
export const AUTH_TOKEN_URL = 'AUTH_TOKEN_URL';
export const GOOGLE_SPOT_GRANT_TYPE = 'GOOGLE_SPOT_GRANT_TYPE';
export const LOGIN_STATE = 'LOGIN_STATE';
export const APP_DEVELOPMENT = 'APP_DEVELOPMENT';
export const RECAPTCHA_SITE_KEY = 'RECAPTCHA_SITE_KEY';
export const RECAPTCHA_BASE_URL = 'RECAPTCHA_BASE_URL';
export const APP_UI_URL = 'APP_UI_URL';
export const APP_STORE_ID = 'APP_STORE_ID';
export const APP_STORE_REVIEW_URL = 'APP_STORE_REVIEW_URL';
export const PLAY_STORE_REVIEW_URL = 'PLAY_STORE_REVIEW_URL';
export const API_REQUEST_TIMEOUT_SEC = 'API_REQUEST_TIMEOUT_SEC';
export const ORDER_STATUS_CHECK_CALLOUT_INTERVAL_SECS = 'ORDER_STATUS_CHECK_CALLOUT_INTERVAL_SECS';
export const TOKEN_EXPIRY_GRACE_PERIOD = 'TOKEN_EXPIRY_GRACE_PERIOD';
export const ORDER_STATUS_CHECK_MAX_WAIT_TIME_SECS = 'ORDER_STATUS_CHECK_MAX_WAIT_TIME_SECS';
export const ORDER_TRACKING_CALLOUT_INTERVAL_SECS = 'ORDER_TRACKING_CALLOUT_INTERVAL_SECS';
export const DEBUG_ANALYTICS_PROVIDERS = 'DEBUG_ANALYTICS_PROVIDERS';
export const ORDER_TRACKING_DISTA_WAIT_TIME_SECS = 'ORDER_TRACKING_DISTA_WAIT_TIME_SECS';
export const USER_RATING_INERVAL = 'USER_RATING_INERVAL';
export const BRAINTREE_MERCHANT_ID = 'BRAINTREE_MERCHANT_ID';
export const BRAINTREE_GPAY_MERCHANT_ID = 'BRAINTREE_GPAY_MERCHANT_ID';
export const BRAINTREE_MERCHANT_NAME = 'BRAINTREE_MERCHANT_NAME';
export const DGFT_MERCHANT_ID = 'DGFT_MERCHANT_ID';
export const DGFT_MERCHANT_NAME = 'DGFT_MERCHANT_NAME';
export const APP_ENVIRONMENT = 'APP_ENVIRONMENT';
export const QR_CODE_VALID_TIME_MINS = 'QR_CODE_VALID_TIME_MINS';
export const ORDER_TRACKING_INTERVAL_MINS = 'ORDER_TRACKING_INTERVAL_MINS';
export const ENCRYPTION_DECRYPTION_ERROR = 'ENCRYPTION_DECRYPTION_ERROR';
export const INACTIVE_PLP_TIMER = 'INACTIVE_PLP_TIMER';
export const INDECISION_PLP_TIMER = 'INDECISION_PLP_TIMER';
export const PULL_DOWN_FIRST_TIME_USER_TIMER = 'PULL_DOWN_FIRST_TIME_USER_TIMER';
export const PULL_DOWN_RETURNING_USER_TIMER = 'PULL_DOWN_RETURNING_USER_TIMER';
export const ORDER_TRACKING_MAP_CALLOUT_INTERVAL_SECS = 'ORDER_TRACKING_MAP_CALLOUT_INTERVAL_SECS';
export const MAP_DIRECTION_BASE_URL = 'MAP_DIRECTION_BASE_URL';
export const SYSTEM_IDLE_TIMEOUT = 'SYSTEM_IDLE_TIMEOUT';
export const CART_CLEARANCE_TIME_24HRS = 'CART_CLEARANCE_TIME_24HRS';
export const GET_ORDER_STATUS_MAX_RETRY_COUNT = 'GET_ORDER_STATUS_MAX_RETRY_COUNT';
export const GET_ORDER_STATUS_MAX_RETRY_INTERVAL_MS = 'GET_ORDER_STATUS_MAX_RETRY_INTERVAL_MS';
export const GET_ORDER_STATUS_MAX_RETRY_DELIVERY_INTERVAL_MS = 'GET_ORDER_STATUS_MAX_RETRY_DELIVERY_INTERVAL_MS';
export const GET_ACTIVE_ORDER_HISTORY_MAX_RETRY_INTERVAL_MS = 'GET_ACTIVE_ORDER_HISTORY_MAX_RETRY_INTERVAL_MS';
export const STORE_CLOSED_MODAL_TIMING = 'STORE_CLOSED_MODAL_TIMING';
export const STORE_CLOSING_SOON_MODAL_TIMING = 'STORE_CLOSING_SOON_MODAL_TIMING';
export const AKAMAI_RESTRICTED_RESOURCE_PATHS = 'AKAMAI_RESTRICTED_RESOURCE_PATHS';
export const ORDER_COMPLETED_WITHOUT_FULFILLMENT_MINS = 'ORDER_COMPLETED_WITHOUT_FULFILLMENT_MINS';
export const CATERING_ORDER_COMPLETED_WITHOUT_FULFILLMENT_MINS = 'CATERING_ORDER_COMPLETED_WITHOUT_FULFILLMENT_MINS';
export const GENERIC_MENU_NAME = 'GENERIC_MENU_NAME';
export const GENERIC_MENU_NAME_CATERING = 'GENERIC_MENU_NAME_CATERING';
export const BRAZE_EMAIL_SUBSCRIPTION_GROUP_ID = 'BRAZE_EMAIL_SUBSCRIPTION_GROUP_ID';
export const BRAZE_SMS_SUBSCRIPTION_GROUP_ID = 'BRAZE_SMS_SUBSCRIPTION_GROUP_ID';
export const PLP_MIN_ITEMS_TO_RENDER = 'PLP_MIN_ITEMS_TO_RENDER';
export const COUNTRY_CODES = {
    IN: 'in',
    AU: 'au',
    CA: 'ca',
    ZA: 'za',
    JP: 'jp',
    TH: 'th',
};
export const GOOGLE_BASE_URL_PROXY = 'GOOGLE_BASE_URL_PROXY';
export const IS_FULLSTORY_ENABLED = 'IS_FULLSTORY_ENABLED';
export const GLOBAL_PAYMENTS_SCRIPT_URL = 'GLOBAL_PAYMENTS_SCRIPT_URL';
export const GLOBAL_PAYMENTS_3DS_FILE_URL = 'GLOBAL_PAYMENTS_3DS_FILE_URL';
export const GLOBAL_PAYMENTS_APPLE_PAY_MERCHANT_NAME = 'GLOBAL_PAYMENTS_APPLE_PAY_MERCHANT_NAME';
export const GLOBAL_PAYMENTS_APPLE_PAY_MERCHANT_IDENTIFIER = 'GLOBAL_PAYMENTS_APPLE_PAY_MERCHANT_IDENTIFIER';
export const GLOBAL_PAYMENTS_APPLE_PAY_CLIENTID = 'GLOBAL_PAYMENTS_APPLE_PAY_CLIENTID';
export const GLOBAL_PAYMENTS_APPLE_PAY_MERCHANT_SESSIONS_URL = 'GLOBAL_PAYMENTS_APPLE_PAY_MERCHANT_SESSIONS_URL';
export const GLOBAL_PAYMENTS_APPLE_PAY_GLOBAL_PAYMENTS_CLIENTID = 'GLOBAL_PAYMENTS_APPLE_PAY_GLOBAL_PAYMENTS_CLIENTID';
export const GLOBAL_PAYMENTS_GOOGLE_PAY_MERCHANT_NAME = 'GLOBAL_PAYMENTS_GOOGLE_PAY_MERCHANT_NAME';
export const GLOBAL_PAYMENTS_GOOGLE_PAY_MERCHANT_ID = 'GLOBAL_PAYMENTS_GOOGLE_PAY_MERCHANT_ID';
export const GLOBAL_PAYMENTS_GOOGLE_PAY_CLIENT_ID = 'GLOBAL_PAYMENTS_GOOGLE_PAY_CLIENT_ID';
export const GLOBAL_PAYMENTS_GOOGLE_PAY_GLOBAL_PAYMENTS_CLIENT_ID = 'GLOBAL_PAYMENTS_GOOGLE_PAY_GLOBAL_PAYMENTS_CLIENT_ID';
export const RNA_PAYMENT_FAILURE = 'RNA_PAYMENT_FAILURE';
export const RNA_PAYMENT_SUCCESS = 'RNA_PAYMENT_SUCCESS';
export const RNA_CARD_VALIDATION_FAILURE = 'RNA_CARD_VALIDATION_FAILURE';
export const GLOBAL_PAYMENTS_TRANSACTIONS_URL = 'GLOBAL_PAYMENTS_TRANSACTIONS_URL';
export const GLOBAL_PAYMENTS_VERIFICATION_URL = 'GLOBAL_PAYMENTS_VERIFICATION_URL';
export const GLOBAL_PAYMENTS_VERSION = 'GLOBAL_PAYMENTS_VERSION';
export const dgftCreditCardTokenGenerationUrl = 'dgftCreditCardTokenGenerationUrl';
export const REACT_APP_ADYEN_CLIENT_KEY = 'REACT_APP_ADYEN_CLIENT_KEY';
